module.exports = __webpack_public_path__ + "img/img23.e2e7e835.jpg";